import List from "@/views/integrations/list.vue";
import GoogleMerchantCenter from "@/views/integrations/google-merchant-center/item.vue";
export default [
  {
    path: "integrations",
    component: List,
    name: "integrations",
    meta: {
      label: "Integrations",
      breadcrumbs: ["integrations"],
    },
  },
  {
    path: "integrations/google-merchant-center",
    name: "google-merchant-center",
    component: GoogleMerchantCenter,
    meta: {
      label: "Google Merchant Center",
      breadcrumbs: ["integrations", "Google Merchant Center"],
    },
  },
];
